import { createAPI } from '@common'
import { create } from 'sortablejs'

export default {
  //获取订阅号榜单分页查询
  getColumnRoots: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno0dpmvnoxfct0sppu', 'get', config),
  // 获取订阅号榜单分页查询
  getinfluenceRank: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno0dpmvnot0tvctdsjcf0jogmvfodfSbol', 'get', config),
  // 获取订阅分类
  getRssCats: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno0dpmvnot0sttDbut', 'get', config),
  // 自定义配置影响力
  getInfluenceInfo: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno0dpmvnot0tvctdsjcf0jogmvfodfJogp', 'get', config),
  // 设置自定义配置影响力
  postInfluenceInfo: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno0dpmvnot0tvctdsjcf0jogmvfodfJogp', 'post', config),
  // 获取初始值
  getInfluenceInitial: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno0dpmvnot0tvctdsjcf0jogmvfodfJojujbm',
      'get',
      config
    ),
  // 设置修改初始值
  postInfluenceInitial: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno0dpmvnot0tvctdsjcf0jogmvfodfJojujbm',
      'post',
      config
    ),
  // 刷新排行榜
  postReload: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno0dpmvnot0tvctdsjcf0sfmpbe', 'post', config),
  // 读微信公众号设置
  getColumnsWeixin: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno0dpmvnot0xfjyjo', 'get', config),
  // 微信公众号设置
  postColumnsWeixin: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno0dpmvnot0xfjyjo', 'post', config),
  // 查询订阅来源配置（微信公众号 / APP）
  getColumnsRssConfig: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno0dpmvnot0stt0dpogjh', 'get', config),
  // 保存订阅来源配置（微信公众号 / APP）

  postColumnsRssConfig: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno0dpmvnot0stt0dpogjh', 'post', config)
}
